export default {
  federal_states: [
    ["BW", "Baden-Württemberg"],
    ["BY", "Bayern"],
    ["BE", "Berlin"],
    ["BB", "Brandenburg"],
    ["HB", "Bremen"],
    ["HH", "Hamburg"],
    ["HE", "Hessen"],
    ["MV", "Mecklenburg-Vorpommern"],
    ["NI", "Niedersachsen"],
    ["NW", "Nordrhein-Westfalen"],
    ["RP", "Rheinland-Pfalz"],
    ["SL", "Saarland"],
    ["SN", "Sachsen"],
    ["ST", "Sachsen-Anhalt"],
    ["SH", "Schleswig-Holstein"],
    ["TH", "Thüringen"]
  ],
  graduations: {
    BW: [
      ["HS", "Hauptschulabschluss"],
      ["RS", "Realschulabschluss"],
      ["GY", "Allgemeine Hochschulreife"],
      ["BG", "Fachhochschulreife"],
      ["FO", "fachgebundene Hochschulreife"]
    ],
    BY: [
      ["HS", "Abschluss der Mittelschule"],
      ["RS", "Mittlerer Schulabschluss"],
      ["GY", "Allgemeine Hochschulreife"],
      ["BG", "Fachhochschulreife"],
      ["FO", "fachgebundene Hochschulreife"]
    ],
    BE: [
      ["HS", "(Erweiterte) Berufsbildungsreife"],
      ["RS", "Mittlerer Schulabschluss"],
      ["GY", "Allgemeine Hochschulreife"],
      ["BG", "Fachhochschulreife"],
      ["FO", "fachgebundene Hochschulreife"]
    ],
    BB: [
      ["HS", "(Erweiterte) Berufsbildungsreife"],
      ["RS", "Fachoberschulreife"],
      ["GY", "Allgemeine Hochschulreife"],
      ["BG", "Fachhochschulreife"]
    ],
    HB: [
      ["HS", "(Erweiterte) Berufsbildungsreife"],
      ["RS", "Mittlerer Schulabschluss"],
      ["GY", "Allgemeine Hochschulreife"],
      ["BG", "Fachhochschulreife"],
      ["FO", "fachgebundene Hochschulreife"]
    ],
    HH: [
      ["HS", "Erster Allgemeinbildender Schulabschluss"],
      ["RS", "Mittlerer Schulabschluss"],
      ["GY", "Allgemeine Hochschulreife"],
      ["BG", "Fachhochschulreife"],
      ["FO", "fachgebundene Hochschulreife"]
    ],
    HE: [
      ["HS", "(Qualifizierender) Hauptschulabschluss"],
      ["RS", "(Qualifizierender) Realschulabschluss"],
      ["GY", "Allgemeine Hochschulreife"],
      ["BG", "Fachhochschulreife"]
    ],
    MV: [
      ["HS", "Berufsreife"],
      ["RS", "Mittlere Reife"],
      ["GY", "Allgemeine Hochschulreife"],
      ["BG", "Fachhochschulreife"]
    ],
    NI: [
      ["HS", "Hauptschulabschluss"],
      ["RS", "Realschulabschluss"],
      ["GY", "Allgemeine Hochschulreife"],
      ["BG", "Fachhochschulreife"],
      ["FO", "fachgebundene Hochschulreife"]
    ],
    NW: [
      ["HS", "Hauptschulabschluss"],
      ["RS", "Fachoberschulreife"],
      ["GY", "Allgemeine Hochschulreife"],
      ["BG", "Fachhochschulreife"],
      ["FO", "fachgebundene Hochschulreife"]
    ],
    RP: [
      ["HS", "Berufsreife"],
      ["RS", "Qualifizierter Sekundarabschluss I"],
      ["GY", "Allgemeine Hochschulreife"],
      ["BG", "Fachhochschulreife"],
      ["FO", "fachgebundene Hochschulreife"]
    ],
    SL: [
      ["HS", "Hauptschulabschluss"],
      ["RS", "Mittlerer Bildungsabschluss"],
      ["GY", "Allgemeine Hochschulreife"],
      ["BG", "Fachhochschulreife"]
    ],
    SN: [
      ["HS", "(Qualifizierter) Hauptschulabschluss"],
      ["RS", "(Erweiterter) Realschulabschluss"],
      ["GY", "Allgemeine Hochschulreife"],
      ["BG", "Fachhochschulreife"]
    ],
    ST: [
      ["HS", "(Qualifizierender) Hauptschulabschluss"],
      ["RS", "Realschulabschluss"],
      ["GY", "Allgemeine Hochschulreife"],
      ["BG", "Fachhochschulreife"]
    ],
    SH: [
      ["HS", "Erster Allgemeinbildender Schulabschluss"],
      ["RS", "Mittlerer Schulabschluss"],
      ["GY", "Allgemeine Hochschulreife"],
      ["BG", "Fachhochschulreife"],
      ["FO", "fachgebundene Hochschulreife"]
    ],
    TH: [
      ["HS", "(Qualifizierender) Hauptschulabschluss"],
      ["RS", "Realschulabschluss"],
      ["GY", "Allgemeine Hochschulreife"],
      ["BG", "Fachhochschulreife"]
    ]
  },
  graduation2sek: {
    HS: "sek1",
    RS: "sek1",
    GY: "sek2",
    BG: "sek2",
    FO: "sek2"
  },
  salutation: [
    ["f", "Frau"],
    ["m", "Herr"],
    ["d", "Divers"]
  ],
  client_types: [
    ["super-admin", "Super-Admin"],
    ["verteilender-mandant", "Verteilender Mandant"],
    ["lizensierender-mandant", "Lizensierender Mandant"],
    ["testender-mandant", "Testender Mandant"],
    ["autolizensierender-mandant", "Autolizensierender Mandant"],
    ["institution-admin", "Institutions-Admin"]
  ],
  user_types: [
    ["admin", "Administrator"],
    ["user", "Benutzer"]
  ],
  interest_groups: [
    ["ihk", "IHK"],
    ["bfa", "Agentur für Arbeit"],
    ["jc", "Jobcenter"],
    ["school", "Schule"],
    ["company", "Unternehmen"],
    ["educational", "Bildungsträger"],
    ["other", "Sonstige"]
  ],
  log_types: [
    ["CLIENT_GOT_ACTIVATED", "Mandant wurde aktiviert"],
    ["CLIENT_ADDED_INSTITUTION", "Mandant hat eine Institution hinzugefügt"],
    ["CLIENT_GOT_LICENCES_ASSIGNED", "Mandant hat Lizenzen zugewiesen bekommen"],
    ["CLIENT_GOT_LICENCES_BACK_FROM_INSTITUTIONEXPIRATIONSTACK", "Mandant hat abgelaufene Lizenzen zurück erhalten"],
    ["CLIENT_ASSIGNED_LICENCES_TO_INSTITUTION", "Mandant hat einer Institution Lizenzen zugewiesen"],
    ["INSTITUTION_GOT_LICENCES_ASSIGNED_BY_CLIENT", "Institution wurden Lizenzen zugewiesen"],
    ["INSTITUTION_ASSIGNED_LICENCES_TO_TESTGROUP", "Institution hat einer Testgruppe Lizenzen zugewiesen"],
    ["LICENCE_WAS_USED", "Lizenz wurde verbraucht"],
    ["INSTITUTION_GENERATED_LICENCES", "Institution hat Lizenzen generiert"]
  ],
  response_codes: [
    ["001", "Mandant wurde angelegt"],
    ["002", "Mandantendaten wurden aktualisiert"],
    ["003a", "Möchten Sie wirklich diesen Mandanten löschen?"],
    ["003b", "Mandant wurde gelöscht"],
    ["004", "Benutzer wurde angelegt"],
    ["005", "Benutzerdaten wurden aktualisiert"],
    ["006a", "Möchten Sie wirklich diesen Benutzer löschen"],
    ["006b", "Benutzer wurde gelöscht"],
    ["007", "Institution wurde angelegt"],
    ["008", "Institutionsdaten wurden aktualisiert"],
    ["009a", "Möchten Sie wirklich diese Institution löschen?"],
    ["009b", "Institution wurde gelöscht"],
    ["009c", "Es wurden keine Institutionen gefunden"],
    ["010", "Eingabefehler: Authentifizierung nicht möglich"],
    ["011", "Eine E-Mail mit weiteren Instruktionen wurde versendet."],
    ["012", "Passwort wurde zurückgesetzt"],
    ["013", "Nachricht wurde gesendet"],
    ["014", "Texte wurden gespeichert"],
    ["015", "Fehler beim Speichern der Daten"],
    ["016", "Datei erfolgreich heruntergeladen"],
    ["016b", "Es liegen keine Ergebnisse vor"],
    ["017", "Es sind noch keine Lizenzvorgänge vorhanden"]
  ],
  pdfProviders: [
    ["default", "Tätigkeitsbereiche"],
    ["mrm_2022", "Berufsbereiche"],
    ["nts_2022", "NaturTalent Stiftung"]
  ]
};
